/** @param {Function} [callback=] */
export const hidePopup = (callback) => {
  $(".searchClicker").fadeOut(function () {
    $(".searchClicker").remove();
    if (callback) callback();
  });
  $(".searchfield").slideUp("fast");
};
